import React from 'react'
import { connect } from 'react-redux';

import InputWithLabel from './../../commons/InputWithLabel'

import {
  assetChanged,
} from '../../../actions'

import {
  getAsset,
  getProviderSelectOptions
} from './../../../reducers';

class Form extends React.Component {

  onChange = (params) => {
    let { asset , assetChanged } = this.props;

    assetChanged({
      ...{ key: asset.key },
      ...params
    })
  }

  render() {
    const {
      availableProviders,
      allowDestroy,
      asset: {
        amount,
        provider,
        errors,
        _destroy,
      }
    } = this.props;

    if (_destroy) {
      return(null)
    }

    return(
      <div>
        <div className="form-row">
          <div className="col-sm-4">
            <InputWithLabel
              label="Value"
              type='currency'
              defaultValue={ amount }
              errorMessage={ errors['amount'] }
              onChange={ (value) => { this.onChange({amount: value}) } }
            />
          </div>
          <div className="col-sm-6">
            <InputWithLabel
              label='Provider'
              type='select'
              defaultValue={ provider }
              errorMessage={ errors['provider'] }
              options={ availableProviders }
              onChange={ (value) => { this.onChange({provider: value}) } }
            />
          </div>
          {
            allowDestroy && (
              <div className='col-sm-2 assets-delete-container'>
                <div
                  className='pointer smaller grey assets-delete'
                  onClick={ () => { this.onChange({'_destroy': 1}) } }
                >
                  Remove
                </div>
              </div>
            )
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const asset = getAsset(state, ownProps.id)
  const availableProviders = getProviderSelectOptions(state, asset.assetType)

  return {
    asset,
    availableProviders,
  }
}

export default connect(mapStateToProps, {
  assetChanged
})(Form);
